import {
  Headings,
  PrimaryButton,
  ModalOverlayWithoutClose,
} from "@sentara-health/optimahealth_web";
import { ReactNode } from "react";
import { t } from "i18next";

export const ModalOverlayWithOutClose = ({
  title,
  content,
  open,
  callBack,
}: {
  title?: string;
  content?: ReactNode;
  open: boolean;
  callBack: () => void;
}) => {
  return (
    <ModalOverlayWithoutClose
      isOpen={open}
      overlayInfo="Modal information"
      className="modal-w-medium"
    >
      <Headings
        className="font-twenty fw-500 mb-2 me-4"
        level={3}
        text={title}
        variant={"medium"}
      />
      <p className="mb-4" data-testid="sessionModalDescription">
        {content}
      </p>
      <div className="text-center">
        <PrimaryButton
          data-testid={"modalOkButton"}
          className={"primary_btn btn_block_mob"}
          type="submit"
          onClick={() => callBack()}
        >
          {t("session.label.buttonOk")}
        </PrimaryButton>
      </div>
    </ModalOverlayWithoutClose>
  );
};
